import React from 'react';
import {
    Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
    Typography, Select, MenuItem, FormHelperText, Alert
} from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';
import { set } from 'lodash';
import { Tabs } from '../../components/tabs';
import { Grid } from '../../components/table';
import { CONFIG } from '../../../config'
import axios from 'axios';
import { ToolBar } from '../../components/toolbar';
import { Modal } from '../../components/modal';
import { FormA } from '../../components/form';
import moment from 'moment';
import {getFormState} from '../../../helpers/form';
import dayjs from 'dayjs';
import {CallerView} from './view';
import {Reports} from './reports';
import Sidebar from './sidebar';
import {CallsView} from './calls-view';
// import {Leaves} from './leaves';
import {MyLeaves} from '../apply-leave/myleaves'
const API_HOST = CONFIG.modules['accounts'].host



const items = {
    'Dashboard': {
        name: 'Dashboard',
        view: ()=><CallerView/>
    },
    'Calls': {
        name: 'Calls',
        view: ()=><CallsView/>
    },
    'Reports': {
        name: 'Reports',
        view: ()=><Reports/>
    },
    'Leaves': {
        name: 'Leaves',
        view: ()=><MyLeaves/>
    },


}
const iframe = '<iframe src="https://in-ccaas.ozonetel.com/toolbar_widget/index.html#dashboard-agent" width="540" height="450"></iframe>'; 


function Iframe(props) {
    return (<div dangerouslySetInnerHTML={ {__html:  props.iframe?props.iframe:""}} />);
  }



export const Caller = (props) => {
    const { roles, user, users, Designations, Departments, Languages, Districts } = useSelector((state) => (state.user || {}))
    const userStore = useSelector((state) => (state.user || {}))

    const [active, setActive] = useState('Dashboard')
    

    return (
        <>
            <Tabs items={items} active={active} onChange={(key) => {
                setActive(key)
            }} />
            {/* <ToolBar name={active}/> */}
           {
                items[active]&& items[active].view &&
                items[active].view()
            }
           
        </>
    )
}